import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  Button,
  Sheet,
  Modal,
  ModalDialog,
  ModalClose,
  DialogTitle,
  DialogContent,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Select,
  ModalOverflow,
  Option,
} from "@mui/joy";
import { toast } from "react-toastify";
import { LoadingView, PageTitle } from "../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { STATUS } from "../../../constant";
import { connect, useDispatch } from "react-redux";
import {
  deactivateAccountRequest,
  activateAccountRequest,
  deactivateAccountReset,
  activateAccountReset,
  viewAccountReset,
  viewAccountRequest,
  rejectAccountRequest,
  rejectAccountReset,
  approveAccountRequest,
  approveAccountReset,
  getPartnerAccountReset,
  getPartnerAccountRequest,
  viewPartnerAccountReset,
  createAccountRequest,
  createAccountReset,
} from "../../../store/actions";
import {
  AddCardOutlined,
  BlockOutlined,
  CheckCircle,
  DoNotDisturbOn,
  TaskAltOutlined,
} from "@mui/icons-material";

function CreateItems(title: String, value: String) {
  return { title, value };
}

const AccountViewPage = ({
  loginResult,

  viewAccountStatus,
  viewAccountResult,
  viewAccountErrorMessage,

  rejectAccountStatus,
  rejectAccountResult,
  rejectAccountErrorMessage,

  approveAccountStatus,
  approveAccountResult,
  approveAccountErrorMessage,

  activateAccountStatus,
  activateAccountResult,
  activateAccountErrorMessage,

  deactivateAccountStatus,
  deactivateAccountResult,
  deactivateAccountErrorMessage,

  viewPartnerAccountStatus,
  viewPartnerAccountResult,
  viewPartnerAccountErrorMessage,

  createAccountStatus,
  createAccountResult,
  createAccountErrorMessage,

  getPartnerAccountStatus,
  getPartnerAccountResult,
  getPartnerAccountErrorMessage,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const {
    account_code,
    agent_id,
    name,
    agentList,
    getActivePartnersResult,
    agentStatus,
    accountsCount,
    user_type,
  } = state;

  const [rejectModal, setRejectModal] = useState(false);
  const [deactivateModal, setDeactivateModal] = useState(false);

  const [account_name, setAccName] = useState("");
  const [account_type, setAccountType] = useState("");
  const [owner, setOwner] = useState("");
  const [status, setStatus] = useState(0);
  const [remark, setRemark] = useState("");
  const [created_by, setCreated] = useState("");
  const [ref_bank_acc, setRefBankAcc] = useState("");
  const [accForm, setAccForm] = useState(false);
  const [accType, setAccType] = useState("");
  const [bankAcc, setBankAcc] = useState("");
  const [bankId, setBankID] = useState("");
  const [assignedUser, setAssignedUser] = useState("");

  useEffect(() => {
    if (viewAccountStatus === STATUS.SUCCESS) {
      setAccName(viewAccountResult.account_name);
      setOwner(viewAccountResult.owner);
      setStatus(viewAccountResult.status);
      setAccountType(viewAccountResult.account_type.toString());
      setRemark(viewAccountResult.remarks);
      const createdBy = viewAccountResult?.created_by;
      setCreated(
        `${createdBy?.first_name || ""} ${createdBy?.middle_name || ""} ${createdBy?.last_name || ""}`,
      );
      setRefBankAcc(viewAccountResult.ref_bank_number);
      setTimeout(() => {
        dispatch(viewAccountReset());
      }, 2000);
    } else if (viewAccountStatus === STATUS.ERROR) {
      toast.error(viewAccountErrorMessage);
      dispatch(viewAccountReset());
    }

    if (approveAccountStatus === STATUS.SUCCESS) {
      toast.success("Account approved successful");
      dispatch(
        viewAccountRequest(loginResult.token, { account_code: account_code }),
      );
      dispatch(approveAccountReset());
    } else if (approveAccountStatus === STATUS.ERROR) {
      toast.error(approveAccountErrorMessage);
      dispatch(approveAccountReset());
    }

    if (rejectAccountStatus === STATUS.SUCCESS) {
      toast.success("Account rejected successful");
      dispatch(
        viewAccountRequest(loginResult.token, { account_code: account_code }),
      );
      setRejectModal(false);
      dispatch(rejectAccountReset());
    } else if (rejectAccountStatus === STATUS.ERROR) {
      toast.error(rejectAccountErrorMessage);
      dispatch(rejectAccountReset());
    }

    if (activateAccountStatus === STATUS.SUCCESS) {
      toast.success("Account activated successful");
      dispatch(
        viewAccountRequest(loginResult.token, { account_code: account_code }),
      );
      dispatch(activateAccountReset());
    } else if (activateAccountStatus === STATUS.ERROR) {
      toast.error(activateAccountErrorMessage);
      dispatch(activateAccountReset());
    }

    if (deactivateAccountStatus === STATUS.SUCCESS) {
      toast.success("Account deactivated successful");
      setDeactivateModal(false);
      dispatch(
        viewAccountRequest(loginResult.token, { account_code: account_code }),
      );
      dispatch(deactivateAccountReset());
    } else if (activateAccountStatus === STATUS.ERROR) {
      toast.error(deactivateAccountErrorMessage);
      dispatch(deactivateAccountReset());
    }

    if (createAccountStatus === STATUS.SUCCESS) {
      toast.success("Account created successful");
      setAccForm(false);
      dispatch(createAccountReset());
      navigate(-1);
    } else if (createAccountStatus === STATUS.ERROR) {
      toast.error(createAccountErrorMessage);
      dispatch(createAccountReset());
    }

    if (user_type === "partner") {
      if (getPartnerAccountStatus === STATUS.SUCCESS) {
        setAccName(getPartnerAccountResult.account_name);
        setOwner(getPartnerAccountResult.owner);
        setStatus(getPartnerAccountResult.status);
        setAccountType(getPartnerAccountResult.account_type.toString());
        setRemark(getPartnerAccountResult.remarks);
        const createdBy = getPartnerAccountResult?.created_by;
        setCreated(
          `${createdBy?.first_name || ""} ${createdBy?.middle_name || ""} ${createdBy?.last_name || ""}`,
        );
        setRefBankAcc(getPartnerAccountResult.ref_bank_number);
        setTimeout(() => {
          dispatch(viewAccountReset());
        }, 2000);
      } else {
        toast.error(viewAccountErrorMessage);
        dispatch(getPartnerAccountReset());
      }
    }
  });

  useEffect(() => {
    if (account_code != "") {
      dispatch(
        viewAccountRequest(loginResult.token, { account_code: account_code }),
      );
    }
  }, []);

  const [accList, setAccList] = useState([]);
  useEffect(() => {
    if (viewPartnerAccountStatus === STATUS.SUCCESS) {
      setAccList(viewPartnerAccountResult);
      dispatch(viewPartnerAccountReset());
    } else if (viewPartnerAccountStatus === STATUS.ERROR) {
      // setAccList([]);
      // toast.error(viewPartnerAccountErrorMessage)
      dispatch(viewPartnerAccountReset());
    }
  }, [viewPartnerAccountStatus]);

  // ------ actions -------------------------
  const approveAccount = () => {
    const data = {
      account_code: account_code,
    };
    dispatch(approveAccountRequest(loginResult.token, data));
  };

  const rejectAccount = (event) => {
    event.preventDefault();
    const data = {
      account_code: account_code,
      remarks: remark,
    };
    dispatch(rejectAccountRequest(loginResult.token, data));
  };

  const activateAccount = () => {
    const data = {
      account_code: account_code,
    };
    dispatch(activateAccountRequest(loginResult.token, data));
  };

  const deactivateAccount = (event) => {
    event.preventDefault();
    const data = {
      account_code: account_code,
      remarks: remark,
    };
    dispatch(deactivateAccountRequest(loginResult.token, data));
  };

  const createAccount = (event) => {
    event.preventDefault();
    if (accType) {
      const datas = {
        wakala_id: agent_id,
        ref_bank_acc: bankAcc,
        ref_bank_id: bankId,
        account_type: accType,
        assigned_user: assignedUser,
        account_name: account_name,
      };
      // alert(JSON.stringify(datas));
      dispatch(createAccountRequest(loginResult.token, datas));
    } else {
      toast.error("Please fill all required information for account creation");
    }
  };

  const handleAccontType = (event, newValue) => {
    setAccType(newValue);
  };

  const handleBankRef = (event, newValue) => {
    setBankID(newValue);
  };

  const handleAssignUser = (event, newValue) => {
    setAssignedUser(newValue);
  };

  const checkLoading = () => {
    if (
      viewAccountStatus === STATUS.LOADING ||
      approveAccountStatus === STATUS.LOADING ||
      rejectAccountStatus === STATUS.LOADING ||
      activateAccountStatus === STATUS.LOADING ||
      deactivateAccountStatus === STATUS.LOADING ||
      createAccountStatus === STATUS.LOADING
    ) {
      return true;
    } else {
      return false;
    }
  };

  const rows = [
    CreateItems("Account Name", account_name),
    CreateItems("Account Type", account_type),
    CreateItems("Account Owner", owner),
    CreateItems(
      "Status",
      {
        1: "Active",
        2: "Inactive",
        3: "Pending for approval",
        4: "Rejected",
        5: "Pending for additional",
      }[status],
    ),
    CreateItems("Created By", created_by),
    CreateItems("Account Code", account_code),
    CreateItems("Bank Account Number", ref_bank_acc),
    CreateItems("Remark", remark),
  ];

  return (
    <Box>
      <PageTitle title={`${account_name} Account Details`} />

      <LoadingView loading={checkLoading()} />

      {/* Contents */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {/* Action Button */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          {/* ---- Only manager can do this actions ----- */}
          {loginResult.role === 2 &&
            status != 4 &&
            (status === 5 ? (
              <>
                <Button
                  color="success"
                  startDecorator={<TaskAltOutlined />}
                  onClick={approveAccount}
                >
                  Approve
                </Button>
                <Button
                  color="warning"
                  startDecorator={<BlockOutlined />}
                  onClick={() => setRejectModal(true)}
                >
                  Reject
                </Button>
              </>
            ) : status === 1 ? (
              <>
                <Button
                  color="danger"
                  startDecorator={<DoNotDisturbOn />}
                  onClick={() => setDeactivateModal(true)}
                >
                  Deactivate
                </Button>
              </>
            ) : status === 2 ? (
              <Button
                color="success"
                startDecorator={<CheckCircle />}
                onClick={activateAccount}
              >
                Activate
              </Button>
            ) : null)}

          {/* only sales officer can create account */}
          {agentStatus === 1 && loginResult.role === 3 && accountsCount < 1 && (
            <Button
              color="neutral"
              startDecorator={<AddCardOutlined />}
              onClick={() => setAccForm(true)}
            >
              Create Account
            </Button>
          )}
        </Box>

        {/* Details */}
        <Box
          sx={{
            gap: 2,
            display: "flex",
            flexDirection: "column",
            width: { xs: "unset", md: "70%" },
          }}
        >
          {/* client details */}
          <Sheet
            className="OrderTableContainer"
            variant="outlined"
            sx={{
              display: "flex",
              // width: '100%',
              borderRadius: "sm",
              flexShrink: 1,
              overflow: "auto",
              minHeight: 0,
            }}
          >
            <Table
              // aria-label="striped table"
              // stripe="odd"
              // variant="soft"
              aria-labelledby="tableTitle"
              stickyHeader
              hoverRow
              sx={{
                "--TableCell-headBackground":
                  "var(--joy-palette-background-level2)",
                "--Table-headerUnderlineThickness": "1px",
                "--TableRow-hoverBackground":
                  "var(--joy-palette-background-level1)",
                "--TableCell-paddingY": "4px",
                "--TableCell-paddingX": "8px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "40%", fontSize: 18 }}>
                    Account Details
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <b>{row.title}</b>
                    </td>
                    <td>{row.value}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Sheet>
        </Box>
      </Box>

      {/* reject modal */}
      <Modal open={rejectModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          // aria-labelledby="modal-dialog-overflow"
          // layout="fullscreen"
          sx={(theme) => ({
            // pt: '600px',
            // minWidth: { xs: 'unset', md: '800px' },
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setRejectModal(false)}
          />
          <DialogTitle>{"Reject account:" + account_name}</DialogTitle>
          <DialogContent>Please write a reason for rejection.</DialogContent>
          <Stack
            component={"form"}
            onSubmit={rejectAccount}
            gap={2}
            sx={{ mt: 2 }}
          >
            {/* rejection reason */}
            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>Rejection reason</FormLabel>
              <Input
                type="text"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter rejection reason"
              />
            </FormControl>

            <Button type="submit" fullWidth>
              REJECT
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>

      {/* deactivate modal */}
      <Modal open={deactivateModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          // aria-labelledby="modal-dialog-overflow"
          // layout="fullscreen"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setDeactivateModal(false)}
          />
          <DialogTitle>{"Deactivate account:" + account_name}</DialogTitle>
          <DialogContent>Please write a reason for deactivation.</DialogContent>
          <Stack
            component={"form"}
            onSubmit={deactivateAccount}
            gap={2}
            sx={{ mt: 2 }}
          >
            {/* rejection reason */}
            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>Deactivate reason</FormLabel>
              <Input
                type="text"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter rejection reason"
              />
            </FormControl>

            <Button type="submit" fullWidth>
              DEACTIVATE
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>

      {/* ------ Modal form for create account ------ */}
      <Modal open={accForm}>
        <ModalOverflow sx={{ pt: "70px" }}>
          <ModalDialog
            aria-labelledby="nested-modal-title"
            aria-describedby="nested-modal-description"
            // aria-labelledby="modal-dialog-overflow"
            // layout="fullscreen"
            sx={(theme) => ({
              // pt: '600px',
              minWidth: { xs: "unset", md: "800px" },
              [theme.breakpoints.only("xs")]: {
                top: "60px",
                bottom: 0,
                left: 0,
                right: 0,
                // borderRadius: 0,
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                transform: "none",
                maxWidth: "unset",
                overflow: "auto",
              },
            })}
          >
            <ModalClose variant="outlined" onClick={() => setAccForm(false)} />
            <DialogTitle>{`Edit ${name} Details`}</DialogTitle>
            <DialogContent>
              Please enter required details for account creation.
            </DialogContent>
            <Stack
              component="form"
              onSubmit={createAccount}
              gap={2}
              sx={{ mt: 2 }}
            >
              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* account name */}
                <FormControl required sx={{ flex: 1 }}>
                  <FormLabel>Account Name</FormLabel>
                  <Input
                    type="text"
                    value={account_name}
                    onChange={(e) => setAccName(e.target.value)}
                    placeholder="Enter account name "
                  />
                </FormControl>

                {/* account type */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Account Type</FormLabel>
                  <Select
                    placeholder="Select account type"
                    value={accType}
                    onChange={handleAccontType}
                    required
                  >
                    <Option value="individual_account">Individual</Option>
                    <Option value="business_account">Business</Option>
                    <Option value="customer_suspense_account">
                      Customer Suspense
                    </Option>
                    <Option value="agent_suspense_account">
                      Agent Suspense
                    </Option>
                  </Select>
                </FormControl>
              </Stack>

              {/* assigned user*/}
              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Assigned to</FormLabel>
                  <Select
                    placeholder="Select agent to assign account"
                    value={assignedUser}
                    onChange={handleAssignUser}
                    required
                  >
                    {agentList?.map((dt) => (
                      <Option value={dt.id}>
                        {dt.first_name +
                          " " +
                          dt.middle_name +
                          " " +
                          dt.last_name}
                      </Option>
                    ))}
                  </Select>
                </FormControl>
              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* bank ref account */}
                <FormControl required sx={{ flex: 1 }}>
                  <FormLabel>Bank Ref Account</FormLabel>
                  <Input
                    type="text"
                    value={bankAcc}
                    onChange={(e) => setBankAcc(e.target.value)}
                    placeholder="Enter bank ref account "
                  />
                </FormControl>

                {/* account type */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Bank Ref</FormLabel>

                  <Select
                    placeholder="Select bank ref"
                    value={bankId}
                    onChange={handleBankRef}
                    required
                  >
                    {getActivePartnersResult?.map((partner) => (
                      <Option key={partner.id} value={partner.id}>
                        {partner.name}
                      </Option>
                    ))}
                  </Select>
                </FormControl>
              </Stack>

              <Stack gap={4} sx={{ mt: 2 }}>
                <Button type="submit" fullWidth>
                  Create Account
                </Button>
              </Stack>
            </Stack>
          </ModalDialog>
        </ModalOverflow>
      </Modal>
    </Box>
  );

  // minor change
};

const mapStateToProps = ({ auth, accounts }) => {
  const { otpResult: loginResult } = auth;
  const {
    viewAccountStatus,
    viewAccountResult,
    viewAccountErrorMessage,

    rejectAccountStatus,
    rejectAccountResult,
    rejectAccountErrorMessage,

    approveAccountStatus,
    approveAccountResult,
    approveAccountErrorMessage,

    activateAccountStatus,
    activateAccountResult,
    activateAccountErrorMessage,

    deactivateAccountStatus,
    deactivateAccountResult,
    deactivateAccountErrorMessage,

    viewPartnerAccountStatus,
    viewPartnerAccountResult,
    viewPartnerAccountErrorMessage,

    createAccountStatus,
    createAccountResult,
    createAccountErrorMessage,

    getPartnerAccountStatus,
    getPartnerAccountResult,
    getPartnerAccountErrorMessage,
  } = accounts;

  return {
    loginResult,

    viewAccountStatus,
    viewAccountResult,
    viewAccountErrorMessage,

    rejectAccountStatus,
    rejectAccountResult,
    rejectAccountErrorMessage,

    approveAccountStatus,
    approveAccountResult,
    approveAccountErrorMessage,

    activateAccountStatus,
    activateAccountResult,
    activateAccountErrorMessage,

    deactivateAccountStatus,
    deactivateAccountResult,
    deactivateAccountErrorMessage,

    viewPartnerAccountStatus,
    viewPartnerAccountResult,
    viewPartnerAccountErrorMessage,

    createAccountStatus,
    createAccountResult,
    createAccountErrorMessage,

    getPartnerAccountStatus,
    getPartnerAccountResult,
    getPartnerAccountErrorMessage,
  };
};

export default connect(mapStateToProps, {})(AccountViewPage);
